import { render, staticRenderFns } from "./ListagemInstrutores.vue?vue&type=template&id=782331c2&scoped=true"
import script from "./ListagemInstrutores.vue?vue&type=script&lang=js"
export * from "./ListagemInstrutores.vue?vue&type=script&lang=js"
import style0 from "./ListagemInstrutores.vue?vue&type=style&index=0&id=782331c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782331c2",
  null
  
)

export default component.exports